var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaTriangle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "576px",
    height: "512px",
    viewBox: "0 0 576 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FA-Triangle 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FA-Triangle",
    fill: "#FF0000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M569.517,440.013 C587.975,472.007 564.806,512 527.94,512 L48.054,512 C11.117,512 -11.945,471.945 6.477,440.013 L246.423,23.985 C264.89,-8.024 311.143,-7.966 329.577,23.985 L569.517,440.013 Z M288,354 C262.595,354 242,374.595 242,400 C242,425.405 262.595,446 288,446 C313.405,446 334,425.405 334,400 C334,374.595 313.405,354 288,354 Z M244.327,188.654 L251.745,324.654 C252.092,331.018 257.354,336 263.727,336 L312.273,336 C318.646,336 323.908,331.018 324.255,324.654 L331.673,188.654 C332.048,181.78 326.575,176 319.691,176 L256.308,176 C249.424,176 243.952,181.78 244.327,188.654 L244.327,188.654 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaTriangle);
export default __webpack_public_path__ + "static/media/FA-Triangle.06574146256a785bfac738da085cd707.svg";
export { ForwardRef as ReactComponent };